<template>
    <v-dialog v-model="dialog" :fullscreen="isMobileAndTablet" max-width="500px">
        <v-card>
            <v-card-title :class="titleClasses" :style="titleStyle">
                <v-icon class="mr-2" color="accent2">mdi-creation</v-icon>
                Premium Code Insights
                <v-spacer />
                <v-icon class="black--text" @click="dialog = false">close</v-icon>
            </v-card-title>

            <v-card-text class="pa-0 pb-2">
                <v-row class="grey lighten-4 ma-auto">
                    <v-col class="text-center">
                        <img alt="Code Insight" class="insight-image my-1" :src="imageSrc" />
                    </v-col>
                </v-row>

                <template v-if="!loading">
                    <v-row>
                        <v-col>
                            <h2 class="text-center my-2 mx-6" style="line-height: 32px;">
                                {{ name }}
                            </h2>
                            <p class="overflow-hidden text-center mb-0 pa-4 py-0 tag-description">
                                {{ description }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col cols="auto" class="pb-0">
                            <v-btn :outlined="isTrialAvailable" depressed
                                :color="isTrialAvailable ? 'primary' : 'accent2'" class="font-weight-bold"
                                :class="{ 'mr-4': isTrialAvailable }" @click="openSubscribeToPremiumDialog">
                                Subscribe To Premium
                            </v-btn>

                            <v-btn v-if="!isLoggedIn || canStartTrial" large class="px-5 fs-16 font-weight-bold"
                                color="accent2" max-height="35" depressed :href="getRoute('trial_signup')">
                                Start Free Trial
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row dense justify="center" v-if="showLearnMore">
                        <v-col cols="auto">
                            <v-btn large text class="px-5 fs-16 mt-2" :href="learnMoreUrl">
                                {{ learnMoreLabel }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>

                <template v-else>
                    <v-progress-linear indeterminate />
                </template>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Mobile from '../../../inc/mixins/mobile';
import { EventNames } from '../../../../classes/EventNames';
import { TagInsightApi } from '../../../../api/TagInsightApi';

export default {
    mixins: [Mobile],
    data() {
        return {
            dialog: false,
            premiumContentCategoryInfo: {},
            loading: false,
            documentId: null
        };
    },
    computed: {
        name() {
            return this.premiumContentCategoryInfo.name || '';
        },
        description() {
            return this.premiumContentCategoryInfo.description || '';
        },
        learnMoreUrl() {
            return this.premiumContentCategoryInfo.learnMoreUrl || '';
        },
        learnMoreLabel() {
            return this.premiumContentCategoryInfo.learnMoreLabel || '';
        },
        isLoggedIn() {
            return this.$store.getters.getLoggedIn !== '';
        },
        isTrialAvailable() {
            return !this.isActiveUser || this.canStartTrial;
        },
        imageSrc() {
            const { codeInsightImage } = this.premiumContentCategoryInfo;
            return codeInsightImage
                ? this.asset(codeInsightImage, 'default')
                : this.asset(require('../../../../images/tagging/upsell_header.png'), 'default');
        },
        showLearnMore() {
            return this.learnMoreUrl && this.learnMoreLabel;
        },
        titleStyle() {
            return {
                borderTop: `4px solid ${this.$vuetify.theme.themes.light.accent2}`
            };
        },
        titleClasses() {
            return [
                'font-weight-bold',
                'oxygen',
                'fs-24',
                { 'caption mobile-title': this.isMobilePort }
            ];
        }
    },
    methods: {
        async getPremiumContentCategoryInfo(data) {
            this.loading = true;
            try {
                const request = {
                    categoryId: data.insightId,
                    type: 'premium'
                };
                const response = await TagInsightApi.getPremiumInsightInfo(request);
                if (response.data?.data?.length) {
                    this.premiumContentCategoryInfo = response.data.data[0];
                }
            } catch (e) {
                console.error('Failed to load tag category info', e);
            } finally {
                this.loading = false;
            }
        },
        openSubscribeToPremiumDialog() {
            this.dialog = true;
            const request = {
                getTitle: true,
                documentId: this.documentId
            };
            EventBus.fire('show-premium-subscribe-dialog', request);
        },
        openDialog(data) {
            this.dialog = true;
            this.documentId = data.documentId;
            this.getPremiumContentCategoryInfo(data);
        }
    },
    mounted() {
        EventBus.listen(EventNames.INSIGHT_RESTRICTED_DIALOG, this.openDialog);
    },
    beforeDestroy() {
        EventBus.off(EventNames.INSIGHT_RESTRICTED_DIALOG, this.openDialog);
    }
};
</script>

<style lang="scss" scoped>
.tag-description {
    max-height: 130px;
    overflow-y: auto;
}

@media (max-width: 820px) {
    .tag-description {
        max-height: 300px;
    }
}

.insight-image {
    width: 75%;
}
</style>
